export default function HeroSection() {
  return (
    <section className="relative h-[40vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-[#3D2817] to-[#E67E50]"></div>
      
      <div className="relative z-10 text-center px-6">
        <h1 className="text-6xl font-bold text-white mb-4">
          PRIVACY POLICY
        </h1>
        <p className="text-xl text-white/90">
          Your data security is our priority
        </p>
      </div>
    </section>
  );
}
